export const onLogoutClick = () => ({
  widget: 'projects',
  type: 'onLogoutClick',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/projects/actions/onLogoutClick.js